export function isNil(value) {
    return value === null || value === undefined;
}
